import { Enviroment } from "../../../_config/constants/enviroment-v2.constant";

export const platformNames = {
	mkt: 'marketplace',
	ecc: 'ecommerce',
	tirxs: Enviroment.COUNTRY === 'MX' ? 'BENESTARX' : 'TIRX',
	pharol: 'pharol',
};
